import { useParams } from 'react-router'
import classnames from 'classnames'
import moment from 'moment/moment'

import { AppStoreBadge, GooglePlayStoreBadge } from 'shared/components/AppDownloadBadge'
import { CardSection } from 'shared/components/CardSection'
import Icon from 'shared/components/Icon'

import styles from './styles.module.scss'

const TicketSuccess = () => {
    const { parkingEnd } = useParams()
    const isValidDate = moment(parkingEnd).isValid()

    return (
        <CardSection>
            <div className="mx-auto text-center">
                <Icon type="check-circle" size="xl" />
                <h3 className="mt-6">
                    <T>scanticket.ticketinfo.success.title</T>
                </h3>
                {isValidDate && (
                    <p className="pt-4 mt-5 mb-6 font-weight-bold text-large">
                        <T>scanticket.ticketinfo.success.exit</T> {moment(parkingEnd).format('MMMM D, YYYY HH:mm')}
                    </p>
                )}
                <p className="pt-4 font-weight-bold">
                    <T>scanticket.ticketinfo.success.apps</T>
                </p>
                <div className="d-flex justify-content-center mt-5 mb-5">
                    <AppStoreBadge imgClass={classnames('mr-4', styles.appLogos)} />
                    <GooglePlayStoreBadge imgClass={styles.appLogos} />
                </div>
            </div>
        </CardSection>
    )
}

export default TicketSuccess
